<template>
  <header>
    <section :class="['detail-header-wrap', gameName]">
      <BaseHeader ref="baseHeader" @login="getLoginResult"></BaseHeader>
      <div class="banner-container">
        <van-swipe
          :autoplay="4000"
          v-show="
            headerImg && typeof headerImg === 'object' && headerImg.length > 0
          "
          @change="onBannerChange"
        >
          <van-swipe-item v-for="(item, index) in headerImg" :key="index">
            <img
              :fetchpriority="index === 0 ? 'high' : 'low'"
              :src="item.picture"
              alt="image"
              @click="jumpPage(item)"
              :class="['game-background-cover', gameName]"
            />
          </van-swipe-item>
        </van-swipe>
        <!-- 底部的遮罩层 -->
        <div class="bottom-mask"></div>
      </div>
      <HeaderCover :text="text" />
    </section>
    <Banner ref="mobileBanner" @login="login" />
  </header>
</template>

<script>
  import BaseHeader from './Base'
  import styleConfiguration from '@/mixins/detail/styleConfiguration'
  import Banner from '@/components/Banner'
  import HeaderCover from '../HeaderCover'
  import { ru_mlbb_banner } from '@/utils/abtest'
  import { pageBannerShow } from '@/pages/firebase'
  import {
    myMlbbDynamicBannerAB,
    idMlbbActBannerAB,
  } from '@page_detail/abTest.js'
  import { fetchDetailConfig } from '@/api/games'
  import { mapState } from 'vuex'
  import { compressWebp } from '@/utils/webp'
  import { getLoginStatus } from '@/utils/login'

  export default {
    mixins: [styleConfiguration],
    components: {
      BaseHeader,
      Banner,
      HeaderCover,
    },
    props: {},
    data() {
      return {
        addShortcutClicked: false,
        headerImg: [],
        titleData: {},
        activeBanner: {},
        exposedId: [],
        hasJudgeLogin: false,
        initLoad: true,
      }
    },
    computed: {
      ...mapState('detail', ['detailBasicConfig']),
      ...mapState([
        'gameName',
        'isMiuiBrowser',
        'isXiaomiDevice',
        'isApp',
        'region',
        'isGetapps',
        'hotfixIsFetchSuccess',
        'source',
        'loginFromCouponPop',
      ]),
      text() {
        const { gameName, titleData, isXiaomiDevice } = this
        // 是否使用米粉的文案
        const notUseXiaomiGame = ['pubgm']
        const useXiaomi =
          notUseXiaomiGame.indexOf(gameName) > -1 ? false : isXiaomiDevice
        // 前缀
        const prefix = {
          displayName: useXiaomi ? 'Topnotch' : ``,
          game_desc: '',
        }
        // 默认文案
        const defaultText = this.getdefaultText(useXiaomi)
        // 如果有从api获取的文案，则使用获取到的文案，否则使用文案库中的文案
        const bannerText = {
          displayName: titleData.mainTitle || defaultText.displayName,
          game_desc: titleData.subTitle || defaultText.game_desc,
        }
        return {
          displayName: prefix.displayName + bannerText.displayName,
          game_desc: prefix.game_desc + bannerText.game_desc,
        }
      },
    },
    watch: {
      detailBasicConfig(newVal) {
        const { bannerConfig, gameShowDetail } = newVal || {}
        const { detailPageBanners } = bannerConfig || {}
        this.titleData = gameShowDetail || {}
        if (this.hotfixIsFetchSuccess && this.hasJudgeLogin) {
          if (detailPageBanners && detailPageBanners.length > 0) {
            // 一元购 uvid 奇数不展示banner
            let bannerDatas = this.getluckyBannerFilter(detailPageBanners)
            if (bannerDatas.length === 0) {
              this.setInitImg()
            } else {
              this.headerImg = bannerDatas || []
            }

            if (this.headerImg.length === 1) {
              this.trackBannerShow(this.headerImg[0])
            }
          } else {
            this.setInitImg()
          }
        }

        this.initLoad = false
      },
      loginFromCouponPop: {
        handler(newVal) {
          this.getLoginResult(newVal)
        },
        deep: true,
      },
    },
    created() {
      if (!process.client) return
      this.setInitImg()
    },
    beforeDestroy() {},
    methods: {
      getdefaultText(useXiaomi) {
        const fgame = this.gameName

        const displayName = this.$te(`${fgame}.displayName`)
          ? this.$t(`${fgame}.displayName`)
          : this.$t(`publicDetails.displayName`, {
              gameName: this.gameName,
            })

        const game_desc = useXiaomi
          ? this.$t('common.mifansText')
          : this.$te(`${fgame}.game_desc`)
          ? this.$t(`${fgame}.game_desc`)
          : this.$t(`publicDetails.game_desc`)

        return {
          displayName,
          game_desc,
        }
      },

      trackBannerShow(item) {
        if (!this.exposedId.includes(item.id)) {
          pageBannerShow({
            list_id: item.id || 0,
            page: this.gameName,
          })
          this.exposedId.push(item.id)
        }
      },
      onBannerChange(index) {
        const item = this.headerImg[index]
        this.trackBannerShow(item)
      },
      handleClickAddShortcut() {
        // 点击创建快捷方式打点 - UV
        if (!this.addShortcutClicked) {
          this.addShortcutClicked = true
        }
      },
      login(type) {
        if (getLoginStatus()) return
        this.$refs.baseHeader && this.$refs.baseHeader.login(type)
      },
      getLoginResult(res) {
        this.$emit('login', res)
        this.hasJudgeLogin = true
        if (!this.hotfixIsFetchSuccess) return
        // 切换登录状态时，重新调用banner接口
        if (!this.initLoad) {
          this.getBannerDatas(false)
        }
      },
      getBannerDatas(cacheFlag) {
        fetchDetailConfig(
          {
            country: this.region,
            game: this.gameName,
            source: this.source,
          },
          {
            cacheFlag,
          }
        )
          .then((res) => {
            const { bannerConfig, gameShowDetail } = res || {}
            const { detailPageBanners } = bannerConfig || {}

            this.titleData = gameShowDetail || {}

            if (detailPageBanners && detailPageBanners.length > 0) {
              const bannerDatas = this.getluckyBannerFilter(detailPageBanners)
              if (bannerDatas.length === 0) {
                this.setInitImg()
              } else {
                this.headerImg = bannerDatas || []
              }
              if (this.headerImg.length === 1) {
                this.trackBannerShow(this.headerImg[0])
              }
            } else {
              this.setInitImg()
            }
          })
          .catch(() => {
            this.setInitImg()
          })
      },
      // 一元购 uvid 奇数不展示banner
      getluckyBannerFilter(detailPageBanners) {
        let bannerDatas = detailPageBanners
        return bannerDatas
      },
      async setInitImg() {
        const _h5BannerPic = this.h5BannerPic || ''
        const picture = await compressWebp(_h5BannerPic)
        this.headerImg = [{ picture }]
        this.trackBannerShow(this.headerImg[0])
      },

      setABTestImage() {
        const ruMlbbBanner = ru_mlbb_banner()
        if (
          this.region === 'ru' &&
          this.gameName === 'mobile-legends' &&
          !!ruMlbbBanner
        ) {
          this.headerImg = [
            {
              picture: ruMlbbBanner,
            },
          ]
          return true
        }
        // id mlbb abtest
        const {
          isHit: idMlbbHit = false,
          bannerImg: idMlbbBannerImg = '',
          actId,
        } = idMlbbActBannerAB() || {}
        if (
          idMlbbHit &&
          this.region === 'id' &&
          this.gameName === 'mobile-legends' &&
          !getLoginStatus()
        ) {
          this.headerImg = [
            {
              picture: idMlbbBannerImg,
              jumpType: 3,
              activityId: actId,
            },
          ]
          return true
        }
        // my mlbb abtest
        const { isHit = false, bannerImg = '' } = myMlbbDynamicBannerAB() || {}
        if (
          isHit &&
          this.region === 'my' &&
          this.gameName === 'mobile-legends'
        ) {
          this.headerImg = [{ picture: bannerImg }]
          return true
        }
        return false
      },
      jumpPage(item) {
        if (this.isGetapps) {
          return
        }
        this.$refs.mobileBanner && this.$refs.mobileBanner.jumpPage(item)
      },
    },
  }
</script>

<style scoped lang="scss" src="./mobile.scss"></style>

<style scoped lang="scss">
  @media screen and (min-device-width: 1080px) {
    @import './mobile.scss';
  }
</style>
